export function fileToBase64(file: string | ArrayBuffer) {
	const base64String = file.toString().replace('data:', '').replace(/^.+,/, '');
	return base64String;
}
